import React from 'react';
import { useEffect,useState,useMemo } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import "../styles/AuditHome.css";
import {DashBoardClinicalAudit} from '../scripts/DashBoardClinicalAudit'

import { Dashboard } from '../scripts/Dashboard';


function AuditHomeTable(data) {
    const [auditedData,setAuditedData]=useState('')
    const [pendingData,setPendingData]=useState('')
    const [completedData,setCompletedData]=useState('')
    const [progressData,setProgressData]=useState('')



    const [activeStyle, setActiveStyle] = useState({
        pending: false,
        inprogress: false,
        completed: false,
        audited:false,
      });
    const handleClick = (value) => {

        sessionStorage.setItem('ActiveTaskID', value);

        window.location.href = '/ClinicalAudit';
    }
 
    const [initialState,setInitialState]=useState(true);

 useEffect(()=>{

   const fetchData=async ()=>{
    try {
        const response = await fetch('https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=10');
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
  
        const data = await response.json();
  
        console.log('Data from API:', data);
        setPendingData(data);
      } catch (error) {
        console.error('API call error:', error.message);
      }


   }

   fetchData()


 },[])

const memoisedActiveStyle=useMemo(()=>activeStyle,[activeStyle])
 useEffect(()=>{
    sessionStorage.setItem('ActiveTileInAuditHome', Object.keys(activeStyle).filter((key) => activeStyle[key]))
 },[memoisedActiveStyle])



  
    const taskQueueApi=async ()=>{ 

       
        try {
            const response = await fetch('https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=10');
            if (!response.ok) {
              throw new Error('Failed to fetch data');
            }
      
            const data = await response.json();
      
            console.log('Data from API:', data);
            setPendingData(data);
          } catch (error) {
            console.error('API call error:', error.message);
          }
        
        setActiveStyle({
        ...activeStyle,
        pending: true,
        inprogress: false,
        completed: false,
        audited:false,
      });
    }

    const taskQueueCompletedApi=async ()=>{ 
        try {
            const response = await fetch('https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=12');
            if (!response.ok) {
              throw new Error('Failed to fetch data');
            }
      
            const data = await response.json();
      
            console.log('Data from API:', data);
            setCompletedData(data);
          } catch (error) {
            console.error('API call error:', error.message);
          }

        setActiveStyle({
        ...activeStyle,
        pending: false,
        inprogress: false,
        completed: true,
        audited:false,
      });}
    const taskQueueInprogressApi=async ()=>{  
        try {
            const response = await fetch('https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=11');
            if (!response.ok) {
              throw new Error('Failed to fetch data');
            }
      
            const data = await response.json();
      
            console.log('Data from API:', data);
            setProgressData(data);
          } catch (error) {
            console.error('API call error:', error.message);
          }
        
        
        setActiveStyle({
        ...activeStyle,
        pending: false,
        inprogress: true,
        completed: false,
        audited:false,
      });}

      const taskQueueAuditedApi=async ()=>{
        try {
            const response = await fetch('https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_audit_tasklist?status_code=15');
            if (!response.ok) {
              throw new Error('Failed to fetch data');
            }
      
            const data = await response.json();
      
            console.log('Data from API:', data);
            setAuditedData(data);
          } catch (error) {
            console.error('API call error:', error.message);
          }
    


        setActiveStyle({
            ...activeStyle,
            pending: false,
            inprogress: false,
            completed: false,
            audited:true,
          });
      }

   
  const dashboardTasklist=[];
    return (
        <>
         <DashBoardClinicalAudit
          type="agent"
          dashboardTasklist={dashboardTasklist}
          handlePending={taskQueueApi}
          handleInprogress={taskQueueInprogressApi}
          handleCompleted={taskQueueCompletedApi}
          handleAudited={taskQueueAuditedApi}
          auditedData={auditedData}
          pendingData={pendingData}
          completedData={completedData}
          progressData={progressData}
          activeStyle={activeStyle}
        ></DashBoardClinicalAudit>
      
        <div className="tablemaincontent">
            <table id="gridSearchData" className="brandTable">
               {(initialState || activeStyle.pending || activeStyle.completed || activeStyle.inprogress)&& !activeStyle.audited && <thead>
                    <tr>
                        <th>Case No.</th>
                        <th>Date of Processing</th>
                        <th>Business Line</th>
                        <th>Review Type</th>
                        <th>Work Type</th>

                        <th>Nurse</th>
                        <th>Supervisor Name</th>

                    </tr>
                </thead>}

               {activeStyle.audited && <thead>
                    <tr>
                        <th>Case No.</th>
                        <th>Date of Processing</th>
                        <th>Last Activity</th>
                        <th>Dispute ID</th>
                        <th>Raise On</th>

                        <th>Dispute Status</th>
                        <th>Score</th>

                    </tr>
                </thead> }
                <tbody className="displayContent">
                    {/* {data.data.map((item, index) => (
                        <tr key={index}>
                            <td><a onClick={() => handleClick(item.CASE_NO)} >{item.CASE_NO}
                            </a>

                            </td>
                            <td>{item.DATE_OF_PROCESSING}</td>
                            <td>{item.BUSINESS_LINE}</td>
                            <td>{item.REVIEW_TYPE}</td>
                            <td>{item.WORK_TYPE}</td>

                            <td>{item.NURSE}</td>
                            <td>{item.SUPERVISOR}</td>

                        </tr>
                    ))} */}
                    {activeStyle.audited && auditedData.body[0]['DisputedCases'].map((item, index) => (
                        <tr key={index}>
                            <td><a onClick={() => handleClick(item.CASE_NO)} >{item.CASE_NO}
                            </a>

                            </td>
                            <td>{item.DATE_OF_PROCESSING}</td>
                            <td>{item.LAST_ACTIVITY}</td>
                            <td>{item.DISPUTE_ID}</td>
                            <td>{item.RAISEDON}</td>

                            <td>{item.DISPUTE_STATUS}</td>
                            <td>{item.SCORE}</td>

                        </tr>
                    ))}
                    {activeStyle.inprogress && progressData.body[0]['InProgress'].map((item, index) => (
                        <tr key={index}>
                            <td><a onClick={() => handleClick(item.CASE_NO)} >{item.CASE_NO}
                            </a>

                            </td>
                            <td>{item.DATE_OF_PROCESSING}</td>
                            <td>{item.BUSINESS_LINE}</td>
                            <td>{item.REVIEW_TYPE}</td>
                            <td>{item.WORK_TYPE}</td>

                            <td>{item.NURSE}</td>
                            <td>{item.SUPERVISOR}</td>

                        </tr>
                    ))}
                    {activeStyle.completed && completedData.body[0]['Completed'].map((item, index) => (
                        <tr key={index}>
                            <td><a onClick={() => handleClick(item.CASE_NO)} >{item.CASE_NO}
                            </a>

                            </td>
                            <td>{item.DATE_OF_PROCESSING}</td>
                            <td>{item.BUSINESS_LINE}</td>
                            <td>{item.REVIEW_TYPE}</td>
                            <td>{item.WORK_TYPE}</td>

                            <td>{item.NURSE}</td>
                            <td>{item.SUPERVISOR}</td>

                        </tr>
                    ))}
                    {initialState || activeStyle.pending && pendingData.body[0]['Pending'].map((item, index) => (
                        <tr key={index}>
                            <td><a onClick={() => handleClick(item.CASE_NO)} >{item.CASE_NO}
                            </a>

                            </td>
                            <td>{item.DATE_OF_PROCESSING}</td>
                            <td>{item.BUSINESS_LINE}</td>
                            <td>{item.REVIEW_TYPE}</td>
                            <td>{item.WORK_TYPE}</td>

                            <td>{item.NURSE}</td>
                            <td>{item.SUPERVISOR}</td>

                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        </>
    );
}





export default AuditHomeTable;
